<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar un nuevo cultivo</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Nombre (*) </label>

                <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
                </el-input>

                <small v-show="name.invalid" class="text-danger">
                  {{ getError('name') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Unidad de medida (*) </label>

                <el-select
                  v-model="formData.unit"
                  v-validate="modelValidations.unit"
                  class="select-primary"
                  name="unit"
                  placeholder="Unidad de medida"
                >
                  <el-option
                    v-for="option in unitsOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="unit.invalid" class="text-danger">
                  {{ getError('unit') }}
                </small>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <el-checkbox v-model="formData.forSale" label="Cultivo para venta" name="forSale"> </el-checkbox>
              </div>
            </div>

            <div class="col-md-8 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker, Select, Option, Checkbox } from 'element-ui';
import { mapFields } from 'vee-validate';

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    crop: {
      type: Object,
      default: () => {
        return {
          name: null,
          unit: null,
          forSale: true,
        };
      },
    },
  },

  data() {
    return {
      validated: false,
      units: ['BOLSA', 'KG'],
      formData: {
        name: this.crop.name,
        unit: this.crop.unit,
        forSale: Boolean(this.crop.forSale),
      },

      modelValidations: {
        name: {
          required: true,
          min: 3,
        },

        unit: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'unit', 'forSale']),
    unitsOptions() {
      return this.units.map((u) => {
        return { label: u, value: u };
      });
    },
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
